import React from 'react';
import '../styles/alertas2.css';
import alerta from '../imgs/otros/error.png';
import gusano from '../imgs/otros/gusano recortado.png';

export default function Alertas2(props) {
    return (
        <div className="alertas2__div--container">
            <div className="alertas2__div--cajon-mensaje">
                <img className='alertas2__img--alerta' src={alerta} alt="alerta.png"/>
                <h2 className="alertas2__h2--mensaje">{props.mensaje}</h2>
                <img className='alertas2__img--gusano' src={gusano} alt="gusano.png"/>
            </div>
        </div>
    )
}
